module.exports = __webpack_public_path__ + "static/media/indian-summer.08bcbdac.jpg";